module.exports = __webpack_public_path__ + "static/media/t-shirts.324e40f4.jpg";